/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
    // Add custom code below this line
    document.addEventListener("theme:product:added", (e) => {
        const cart = e.target.querySelector('cart-drawer');
        console.log(cart, cart.querySelectorAll('.cart__price'))
        //yourCustomFunction(id, quantity);
    });

    function yourCustomFunction(id, quantity) {
        // Custom logic for handling the cart update
        console.log(`Handling cart update for product ID: ${id}, new quantity: ${quantity}`);
    }
})();